/**
 * @Description: VIP_V2_INDEX
 * @author XuZiYu
 * @date 2021/12/07 19:00:19
*/
<template>
  <div class="wrapper-index">
    <component :is="componentName" :vipData="vipData" :userInfo="userInfo" @refresh="getVipData"></component>
  </div>
</template>

<script>
import open from './open'
import opened from './opened'
import { Toast } from 'vant'

export default {
    name: 'vipV2',
    data () {
        return {
            // 组件名称
            componentName: '',
            // vip数据
            vipData: {},
            // 用户数据
            userInfo: {}
        }
    },
    watch: {
        // 初始化滚动条
        flag () {
            document.body.scrollTop = 0
        }
    },
    components: {
        opened: opened,
        open: open
    },
    methods: {
        // 获取vip数据
        getVipData () {
            this.$api.getVipMatchEntry({
                version: '-1000',
                appType: this.appType
            }).then(res => {
                if (res.status) {
                    this.vipData = res.result

                    this.componentName = this.vipData.vipFlag ? 'opened' : 'open'
                } else {
                    Toast.fail(res.message)
                }
            })
        },
        // 初始化
        init () {
            // 获取用户数据
            if (window.app.passUserInfo) {
                this.userInfo = window.app.passUserInfo() ? JSON.parse(window.app.passUserInfo()) : {}
            }

            // 设置app类型
            this.appType = window.app.getAppType ? window.app.getAppType() : (typeof this.$route.query.appType === 'object' ? this.$route.query.appType[0] : this.$route.query.appType)
        }
    },
    created () {
        this.init()

        this.getVipData()
    }
}
</script>

<style scoped>

</style>
